import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { cdnUrlConfig } from '../../Utils/atoms';

const IntroComponent = () => {
    //imgAnimal 이미지 클래스 스크립트
    const [imgAnimal, SetImgAnimal] = useState(false);
    const cdnUrl = useRecoilValue(cdnUrlConfig);
    const IMG_URL = `${cdnUrl}/BigglzEvent`;

    useEffect(() => {
        setTimeout(() => { SetImgAnimal(true) }, 1000)
    }, [])

    return (
        <div className="part1">
            <div className="layout">
                <div className="txt-area">
                    <h2>
                        <span className="txt-sub">나랑 제일 찰떡인 반려짝꿍은?</span>
                        <span className="txt-test">
                            <img src={`${IMG_URL}/images/mbti/mbti_tit.png`} alt="반려짝꿍 테스트" />
                        </span>
                    </h2>
                    <div className="txt">너는 내 DESTINY! <span>나의 운명의 반려짝꿍을 알아보자!</span></div>
                </div>
                <div className={`img-animal ${imgAnimal ? 'on' : ''}`}>
                    <figure>
                        <figcaption>반려동물</figcaption>
                        <img src={`${IMG_URL}/images/mbti/mbti_img_animal.png`} alt="반려동물 일러스트" />
                    </figure>
                </div>
                <div className="btn-area start">
                    <Link to="/mbti/examine">테스트 시작!</Link>
                    {/* <Link to="/mbti/test">결과전체보기(개발테스트용)</Link> */}
                </div>
            </div>
            {/* <div className="layout">
                <p className="txt-share">
                    <span><strong><img src="/images/mbti/mbti_tit.png" alt="반려짝꿍 테스트" /></strong> 후</span>
                    <span>테스트 결과를 <i className="hash-tag">#비글즈</i><i className="hash-tag">#반려짝꿍이벤트</i></span>
                    <span><i className="highlight">태그를 걸어 인스타에 공유</i> 해주세요.</span>
                    <span>푸짐한 선물이 추첨을 통해 쏟아져요!</span>
                </p>
                <div className="schedule-box">
                    <div className="tit">이벤트 일정</div>
                    <div className="txt">
                        <span><strong>이벤트 기간</strong> 2022년 5월 12일(목) ~ 6월 30일(목)</span>
                        <span><strong>당첨자 발표</strong> 2022년 7월 1일(금)</span>
                    </div>
                </div>
                <div className="reward-box">
                    <div className="tit">이벤트 보상</div>
                    <div className="reward-area">
                        <div className="reward">
                            <div className="first">
                                <div className="num">1명</div>
                                <div className="name">
                                    <strong>네스프레소</strong> 에센자 미니
                                </div>
                                <div className="img">
                                    <figure>
                                        <figcaption>네스프레소 에센자 미니</figcaption>
                                        <img src="/images/mbti/mbti_img_1st.png" alt="네스프레소 에선자 미니 사진" />
                                    </figure>
                                </div>
                            </div>
                        </div>
                        <div className="reward">
                            <div className="num">2명</div>
                            <div className="name">
                                <strong>탬버린즈</strong> 퍼퓸 핸드크림
                            </div>
                            <div className="img">
                                <figure>
                                    <figcaption>탬버린즈 퍼퓸 핸드크림</figcaption>
                                    <img src="/images/mbti/mbti_img_2nd.png" alt="탬버린즈 퍼퓸 핸드크림 사진" />
                                </figure>
                            </div>
                        </div>
                        <div className="reward">
                            <div className="num">5명</div>
                            <div className="name">
                                <strong>스타벅스</strong> 기프트카드 1만원권
                            </div>
                            <div className="img">
                                <figure>
                                    <figcaption>스타벅스 기프트카드 1만원권</figcaption>
                                    <img src="/images/mbti/mbti_img_3rd.png" alt="스타벅스 기프트카드 1만원권 사진" />
                                </figure>
                            </div>
                        </div>
                        <div className="reward">
                            <div className="num">20명</div>
                            <div className="name">
                                <strong>비글즈</strong> 한정 아이템
                            </div>
                            <div className="img">
                                <figure>
                                    <figcaption>비글즈 한정 아이템</figcaption>
                                    <img src="/images/mbti/mbti_img_4th.png" alt="비글즈 한정 아이템 사진" />
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="tip">
                <dl>
                    <dt>확인해주세요!</dt>
                    <dd>#비글즈 #반려짝꿍이벤트 태그를 꼭 달아주셔야 추첨이 가능합니다.</dd>
                    <dd>공유 글에 본 이벤트와 관계없는 내용을 기재 시 추첨 내역에서 제외 될 수 있습니다.</dd>
                    <dd>당첨자는 당첨 발표일까지 비글즈 계정 팔로잉을 유지하는 고객을 대상으로 선정됩니다.</dd>
                    <dd>당첨 경품 수령 관련 상세 내용은 당첨 발표 시 안내될 예정이며, 안내에 따른 추가 정보 회신(메일)이 필요합니다.</dd>
                </dl>
            </div> */}
        </div>
    )
}

export default IntroComponent